<!--
 * @Descripttion: c端预览
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="c-preview">
    <img class="phone" src="@/assets/phone.png" alt="" />
    <div class="preview">
      <iframe
        id="iframe"
        :src="ifrSrc"
        frameborder="0"
        scrolling="no"
        width="355px"
        height="670px"
      ></iframe>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { withDefaults, defineProps, ref } from 'vue';
import { useShareWebviewTaskUrl } from '@hooks/webview';

const props = withDefaults(
  defineProps<{
    projectId: number;
    projectType: number;
    informationId: number;
    taskId: number;
    showType?: 'feedback' | 'information'; // feedback反馈内容，information列表数据
    targetType?: number; // 客户类型
  }>(),
  {}
);

// C端预览地址
const ifrSrc = ref(
  useShareWebviewTaskUrl({
    projectId: props.projectId,
    projectType: props.projectType,
    informationId: props.informationId,
    taskId: props.taskId,
    showType: props.showType || 'information',
    targetType: props.targetType || 4
  })
);
</script>

<style lang="scss" scoped>
.c-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 750px;
  width: 400px;
  .phone {
    width: 400px;
    height: 770px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .preview {
    width: 356px;
    height: 664px;
    overflow-y: hidden;
    overflow-x: hidden;
    margin: auto;
    position: absolute;
    left: 23px;
    top: 55px;
  }
}
</style>
